<template>
  <div>
    <p v-if="label" class="bold">{{ label }}</p>
    <input
      v-bind="$attrs"
      :class="classString"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    classString: {
      type: String,
      default: 'outlined'
    }
  }
}
</script>

<style scoped>
.color {
  color: -internal-light-dark(black, white);
  height: 43px;
  width: 100px;
  border-width: 1px;
  border-style: solid;
  border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
  border-image: initial;
  padding: 6px 12px !important;
}
</style>
